module.exports = __webpack_public_path__ + "static/img/b4-1.e3d43b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b4-1.png
// module id = wWp5
// module chunks = 1